import styled from 'styled-components'

const darkColor = (props) => props.theme.global.colors['dark-2']
const lightColor = (props) => props.theme.global.colors['white']

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${lightColor};
  margin-bottom: 24px;
`

export const Heading = styled.h1`
  font-size: 16px;
  color: ${darkColor};
  font-weight: 500;
  line-height: 26.4px;
  margin: 0 0 16px;

  @media screen and (max-width: 992px) {
    font-size: 14px;
  }
`